import { Type } from '../../../../general/modules/filter/dataModel';
import { Column, FMColumn } from '../model';
import { FilterEnumContainer } from '../components/plugins/filters/FilterEnumContainer';
import { CreativeNameCell } from '../components/cells/CreativeNameCell';

export const creativeNameCol: FMColumn<Type.ID> = {
  key: Column.creative_name,
  dataKey: Column.creative_name,
  title: 'Creative name',
  minWidth: 350,
  sortable: true,
  cellRenderer: CreativeNameCell,
  className: 'ch-file-manager__cell_creative_name',
  plugins: [FilterEnumContainer],
  getter: (row) => row.creative_name ?? null,
  toDisplayString: (row) => row.creative_name ?? null,
};
